import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import mammoth from "mammoth";
import * as pdfjsLib from "pdfjs-dist/build/pdf";
import pdfWorker from "pdfjs-dist/build/pdf.worker.entry";
import Loader from "../../../services/loader";

pdfjsLib.GlobalWorkerOptions.workerSrc = URL.createObjectURL(
  new Blob([pdfWorker], { type: "application/javascript" })
);

export default function Watermark({file, onDone, startLoader, stopLoader }) {
  const { state } = useLocation();
  const dispatch = useDispatch();
  const [isImage, setIsImage] = useState(false);
  const [previewImages, setPreviewImages] = useState([]);
  const [isPDF, setIsPDF] = useState(false);
  const [watermarkText, setWatermarkText] = useState("Confidential");
  const [watermarkDegree, setWatermarkDegree] = useState(0);
  const [watermarkFontSize, setWatermarkFontSize] = useState(10);
  const [isConverting, setIsConverting] = useState(false);

  console.log(file,"ffffffffffff")

  const renderPDF = async (file) => {
    const pdfData = await file.arrayBuffer();
    const pdf = await pdfjsLib.getDocument({ data: pdfData }).promise;

    const images = await Promise.all(
      Array.from({ length: pdf.numPages }, async (_, i) => {
        const page = await pdf.getPage(i + 1);
        const scale = 1.5;
        const viewport = page.getViewport({ scale });

        const canvas = document.createElement("canvas");
        const context = canvas.getContext("2d");
        canvas.height = viewport.height;
        canvas.width = viewport.width;

        await page.render({ canvasContext: context, viewport }).promise;
        return canvas.toDataURL();
      })
    );

    setPreviewImages(images);
  };

  const renderText = async (file) => {
    const text = await file.text();
    setPreviewImages([text]);
  };

  const renderWord = async (file) => {
    const arrayBuffer = await file.arrayBuffer();
    const { value } = await mammoth.convertToHtml({ arrayBuffer });
    const pages = value.split('<div style="page-break-before:always;"></div>');
    const firstPageHTML = pages.length > 0 ? pages[0] : value;

    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = firstPageHTML;
    setPreviewImages([tempDiv.innerHTML]);
  };

  const renderImage = (file) => {
    const reader = new FileReader();
    reader.onload = () => {
      setPreviewImages([reader.result]);
    };
    reader.readAsDataURL(file);
  };

  useEffect(() => {
    if (file) {
      // const file = state.data1?.file;
      const fileName = file?.name || "";
      if (fileName.endsWith(".pdf")) {
        setIsPDF(true);
        renderPDF(file);
      } else if (/\.(jpe?g|png|bmp|gif|webp)$/i.test(fileName)) {
        setIsImage(true);
        renderImage(file);
      } else if (fileName.endsWith(".docx") || fileName.endsWith(".doc")) {
        renderWord(file);
      } else if (fileName.endsWith(".txt")) {
        renderText(file);
      } else {
        setPreviewImages([URL.createObjectURL(file)]);
      }
    }
  }, [state]);

  const handleWatermarkDone = async () => {
  // const file = state?.data1?.file;
  if (!file || (!file.name.endsWith(".pdf") && !isImage)) return;

  setIsConverting(true);
  if (startLoader) startLoader();

  if (isPDF) {
    const fileReader = new FileReader();
    fileReader.onload = async () => {
      const typedArray = new Uint8Array(fileReader.result);
      const pdf = await pdfjsLib.getDocument({ data: typedArray }).promise;

      const scale = 2;
      const blobArray = await Promise.all(
        Array.from({ length: pdf.numPages }, async (_, i) => {
          const page = await pdf.getPage(i + 1);
          const viewport = page.getViewport({ scale });

          const canvas = document.createElement("canvas");
          const context = canvas.getContext("2d");
          canvas.width = viewport.width;
          canvas.height = viewport.height;

          await page.render({ canvasContext: context, viewport }).promise;

          // Apply watermark
          context.save();
          context.font = `${watermarkFontSize * 4}px Arial`;
          context.fillStyle = "rgba(255, 112, 105, 0.4)";
          context.translate(canvas.width / 2, canvas.height / 2);
          context.rotate((parseFloat(watermarkDegree) * Math.PI) / 180);
          context.textAlign = "center";
          context.fillText(watermarkText, 0, 0);
          context.restore();

          return await new Promise((resolve) => {
            canvas.toBlob((b) => resolve(b), "image/png");
          });
        })
      );

      if (typeof onDone === "function") onDone(blobArray);
      if (stopLoader) stopLoader();
      setIsConverting(false);
    };

    fileReader.readAsArrayBuffer(file);
  }

  if (isImage) {
    const canvasList = await new Promise((resolve) => {
      const img = new Image();
      img.onload = () => {
        const scale = 2;
        const canvas = document.createElement("canvas");
        canvas.width = img.width * scale;
        canvas.height = img.height * scale;
        const context = canvas.getContext("2d");

        context.drawImage(img, 0, 0, canvas.width, canvas.height);

        // Watermark
        context.save();
        context.translate(canvas.width / 2, canvas.height / 2);
        context.rotate((parseFloat(watermarkDegree) * Math.PI) / 180);
        context.fillStyle = "rgba(255, 112, 105, 0.4)";
        context.font = `${watermarkFontSize * 4}px Arial`;
        context.textAlign = "center";
        context.fillText(watermarkText, 0, 0);
        context.restore();

        resolve([canvas]);
      };
      img.src = URL.createObjectURL(file);
    });

    const blobArray = await Promise.all(
      canvasList.map(
        (canvas) =>
          new Promise((resolve) => {
            canvas.toBlob((blob) => resolve(blob), "image/png");
          })
      )
    );

    if (typeof onDone === "function") onDone(blobArray);
    if (stopLoader) stopLoader();
    setIsConverting(false);
  }
};


  return (
    <div
      className="modal fade"
      id="create-watermark"
      tabIndex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered model-custom-centered-microtext">
        <div className="modal-content microtext-modal-wrapper">
          <div className="microtext-modal-content">
            <img className="orange-wave" src="/images/orange-wave.svg" alt="" />
            <img className="blue-wave" src="/images/blue-wave.svg" alt="" />
            <button
              className="btn p-0 rounded-circle border-0 shadow-none cut-icon"
              data-bs-dismiss="modal"
            >
              <img src="/images/icons/icon-cross-red.svg" alt="cut" />
            </button>

            <div className="microtext-modal-header">
              <div className="w-100 uploaded-cards-wrapper-issuer-popup">
                <div className="upload-cards bdrs12">
                  <div className="bottom-content-wrapper">
                    <div className="bottom-content">
                      {isPDF ? (
                        <div className="pdf-scroll-container">
                          <div className="pdf-page-container">
                            {previewImages.map((imgData, index) => (
                              <div key={index} style={{ position: "relative" }}>
                                <img
                                  src={imgData}
                                  alt={`PDF page ${index + 1}`}
                                />
                                {watermarkText && (
                                  <div
                                    style={{
                                      position: "absolute",
                                      top: "50%",
                                      left: "50%",
                                      transform: `translate(-50%, -50%) rotate(${watermarkDegree}deg)`,
                                      color: "rgba(255, 112, 105, 0.4)",
                                      fontSize: `${watermarkFontSize * 4}px`,
                                      whiteSpace: "nowrap",
                                      pointerEvents: "none",
                                    }}
                                  >
                                    {watermarkText}
                                  </div>
                                )}
                              </div>
                            ))}
                          </div>
                        </div>
                      ) : isImage ? (
                        <div className="image-micotext">
                          <img src={previewImages[0]} alt="Uploaded image" />
                          {watermarkText && (
                            <div
                              style={{
                                position: "absolute",
                                top: "50%",
                                left: "50%",
                                transform: `translate(-50%, -50%) rotate(${watermarkDegree}deg)`,
                                color: "rgba(255, 112, 105, 0.4)",
                                fontSize: `${watermarkFontSize * 4}px`,
                                whiteSpace: "nowrap",
                                pointerEvents: "none",
                              }}
                            >
                              {watermarkText}
                            </div>
                          )}
                        </div>
                      ) : (
                        <div>No image or PDF to display</div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="microtext-btn">
              <input
                type="text"
                className="border-0 bdrs10 fz14 watermark-input"
                placeholder="Write watermark text here..."
                value={watermarkText}
                onChange={(e) => setWatermarkText(e.target.value)}
              />
              <label className="d-block">Rotate: {watermarkDegree}°</label>
              <input
                type="range"
                min="0"
                max="360"
                value={watermarkDegree}
                onChange={(e) => setWatermarkDegree(e.target.value)}
              />

              <label className="d-block mt-2">
                Size: {watermarkFontSize}px
              </label>
              <input
                type="range"
                min="10"
                max="50"
                value={watermarkFontSize}
                onChange={(e) => setWatermarkFontSize(Number(e.target.value))}
                className="w-50"
              />

              <button
                className="text-uppercase bdrs10 fw600 fz10 btn btn-solid btn-solid--dark microtext-btn-popop"
                data-bs-toggle="modal"
                data-bs-target="#create-watermark"
                onClick={handleWatermarkDone}
              >
                Done
              </button>
            </div>
          </div>
        </div>
      </div>

      <Loader show={isConverting} />
    </div>
  );
}
